export default __webpack_public_path__ + "static/media/reddownarrow.ebc279ab.svg";